import { NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { ContactComponent } from "@app/pages/more/contact/contact.component";
import { PipesModule } from "@app/pipes/pipes.module";
import { TermsAndConditionsComponent } from "@app/pages/more/termsandconditions/termsAndConditions.component";
import { PrivacyPolicyComponent } from "@app/pages/more/privacypolicy/privacyPolicy.component";
import { FAQComponent } from "@app/pages/more/faq/faq.component";
import { MooBankComponent } from "@app/pages/more/moobank/moobank.component";
import { AccountComponent } from "@app/pages/more/account/account.component";
import { FormsModule } from "@angular/forms";
import { SharedComponentModule } from "@app/components/shared.component.module";
import { MaterialModule } from "@app/components/material.module";
import { DirectivesModule } from "@app/components/directives.module";
import { AppRoutingModule } from "@app/app-routing.module";
import { HttpClientModule } from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ComponentsModule } from "@app/components/components.module";
import { DialogModule } from "@app/components/dialog.module";
import { ServicesModule } from "@app/services/services.module";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatIconModule } from "@angular/material/icon";

@NgModule({
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        HttpClientModule,
        BrowserAnimationsModule,
        PipesModule,
        SharedComponentModule,
        MaterialModule,
        DirectivesModule,
        ComponentsModule,
        DialogModule,
        ServicesModule,
        MatTooltipModule,
        MatIconModule,
    ],
    exports: [],
    declarations: [
        PrivacyPolicyComponent,
        TermsAndConditionsComponent,
        FAQComponent,
        ContactComponent,
        MooBankComponent,
        AccountComponent,
        MooBankComponent,
    ],
    providers: [],
    schemas: [NO_ERRORS_SCHEMA],
})
export class MoreModule {}
